const $searchBtn = $(".js-search-btn");
const $searchPopup = $(".js-popup-search");
const $document = $(document);

$searchBtn.on("click", function () {
  if (window.location.href.includes("search")) {
    return false;
  } else {
    $searchPopup.addClass("is-active");
  }
});

$document.keyup(function (e) {
  if (e.key === "Escape") {
    $searchPopup.removeClass("is-active");
  }
});

$document.on("click", function (evn) {
  const $target = $(evn.target);

  if (
    !$target.closest($searchBtn).length &&
    !$target.closest($searchPopup).length
  ) {
    $searchPopup.removeClass("is-active");
  }
});
